export var ClientPlatType;
(function (ClientPlatType) {
    ClientPlatType[ClientPlatType["DESKTOP"] = 1] = "DESKTOP";
    ClientPlatType[ClientPlatType["MOBILE"] = 2] = "MOBILE";
    ClientPlatType[ClientPlatType["APP"] = 3] = "APP";
})(ClientPlatType || (ClientPlatType = {}));
export var ClientPlatStrType;
(function (ClientPlatStrType) {
    ClientPlatStrType["PC"] = "pc";
    ClientPlatStrType["H5"] = "h5";
    ClientPlatStrType["APP"] = "app";
})(ClientPlatStrType || (ClientPlatStrType = {}));
//# sourceMappingURL=ClientPlatType.js.map